import { takeEvery, updateStore } from "starfx";

import { schema as db } from "@app/statefx/schema";
import { xThunk } from "@app/statefx/xapis";
import { EnuAppOps, ThunkCtx } from "@app/types/insider";

import type { Next } from "starfx";

export const applog = xThunk.create<{
  operation: keyof typeof EnuAppOps;
  value?: string;
}>(
  "thunks/applog",
  { supervisor: takeEvery },
  function* (ctx: ThunkCtx, next: Next) {
    const { operation, value = "" } = ctx.payload;
    const timestamp = Date.now();
    yield* updateStore(
      db.applog.add({
        [`${timestamp}-${operation}`]: { operation, value, timestamp },
      })
    );
    yield* next();
  }
);
/* 
runThunk(applog, )
*/
